export default "__VITE_ASSET__CEhbgljM__"